/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Forge Design Automation team for Inventor
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '@hig/modal';
import { CloseMUI } from "@hig/icons";
import Typography from "@hig/typography";
import './modalContact.css';
import merge from "lodash.merge";
import Button from '@hig/button';
import IconButton from "@hig/icon-button";
import Input from '@hig/input';
import { getActiveProject } from '../reducers/mainReducer';
import { hideModalContact } from '../actions/uiFlagsActions';

export class ModalContact extends Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                name: {
                    label: "Nome",
                    value: "",
                    validation: (v) => !!v
                },
                email: {
                    label: "E-mail",
                    value: "",
                    validation: (v) => v.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)
                },
                job: {
                    label: "Professione",
                    value: ""
                },
                company: {
                    label: "Societa\u0300",
                    value: ""
                },
                address: {
                    label: "Indirizzo",
                    value: ""
                },
                city: {
                    label: "Citta\u0300",
                    value: ""
                },
                state: {
                    label: "Stato/Provincia",
                    value: ""
                },
                country: {
                    label: "Paese",
                    value: ""
                },
                zipcode: {
                    label: "Codice postale",
                    value: ""
                },
                telephone: {
                    label: "Telefono",
                    value: ""
                },
                comments: {
                    label: "Commenti",
                    value: ""
                }
            },
            submitState: 0
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange = (e) => {
        this.setState({
            form: { ...this.state.form, [e.target.name]: { ...this.state.form[e.target.name], value: e.target.value } }
        });
    }

    submitForm = (e) => {
        e.preventDefault();

        if (this.state.submitState == 1)
        {
            return;
        }

        const project = this.props.activeProject;

        if (!project)
        {
            this.setState({ message: "Required data missing (no 'Project' selected).", submitState: 0 });
            return;
        }

        const projectName = project.label;

        if (!projectName)
        {
            this.setState({ message: "Required data missing (no 'Project' selected).", submitState: 0 });
            return;
        }

        const projectModelDownloadUrl = project.modelDownloadUrl;

        let bValidate = true;
        let sValidationMessage = "";

        Object.keys(this.state.form).forEach(k => {
            if (!bValidate)
            {
                return;
            }

            if (this.state.form[k].validation)
            {
                if (!this.state.form[k].validation(this.state.form[k].value))
                {
                    sValidationMessage = "Required data missing or invalid (" + this.state.form[k].label + ").";
                    bValidate = false;
                }
            }
        });

        if (!bValidate)
        {
            this.setState({ message: sValidationMessage, submitState: 0 });
            return;
        }

        this.setState({ message: "", submitState: 1 });

        const parameters = {
            project: projectName,
            modelDownloadUrl: projectModelDownloadUrl
        };

        Object.keys(this.state.form).forEach(k => {
            parameters[k] = this.state.form[k].value;
        });

        fetch("/contact", {
            method: "POST",
            body: JSON.stringify(parameters),
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then(async (response) => {
            if (response.ok)
            {
                this.setState({ message: "Submitted successfully.", submitState: 2 });
            }
            else
            {
                throw "";
            }
        })
        .catch(() => {
            this.setState({ message: "Submitting failed due to network error.", submitState: 3 });
        });
    }

    onClose = () => {
        this.setState({ message: "", submitState: 0 });

        if (this.props.onClose)
        {
            this.props.onClose();
        }

        this.props.hideModalContact();
    }

    render() {
        const modalStyles = /* istanbul ignore next */ styles =>
            merge(styles, {
                modal: {
                    window: {
                        top: "32px",
                        width: "90%",
                        height: "auto",
                        minWidth: "450px",
                        maxWidth: "1024px",
                        borderLeftStyle: "solid",
                        borderLeftWidth: "thick",
                        borderLeftColor: "blue",
                        fontSize: "0.7rem"
                    }
                }
            });

        const inputStyles =
        {
            height: "28px"
        };

        return (
            <Modal
                open={this.props.open}
                title={this.props.title}
                onCloseClick={this.onClose}
                stylesheet={modalStyles}
                headerChildren={
                    <header id="customHeader">
                        <div className="customHeaderContent">
                            <div className="title">
                                <Typography style={{
                                    paddingLeft: "8px",
                                    fontSize: "inherit",
                                    fontWeight: "inherit",
                                    lineHeight: "inherit"
                                }}>{this.props.title}</Typography>
                            </div>
                            <IconButton style={{ width: "24px", height: "24px", marginLeft: "auto", marginRight: "auto" }}
                                icon={<CloseMUI />}
                                onClick={this.onClose}
                                title=""
                            />
                        </div>
                    </header>
                }
            >
                <div className="modalContactContent">
                    <form>
                        <div className="input-group">
                            <label htmlFor="name">{this.state.form.name.label}</label>
                            <Input type="text" name="name" id="name" variant="box"
                                value={this.state.form.name.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="email">{this.state.form.email.label}</label>
                            <Input type="text" name="email" id="email" variant="box"
                                value={this.state.form.email.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="job">{this.state.form.job.label}</label>
                            <Input type="text" name="job" id="job" variant="box"
                                value={this.state.form.job.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="company">{this.state.form.company.label}</label>
                            <Input type="text" name="company" id="company" variant="box"
                                value={this.state.form.company.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="">{this.state.form.address.label}</label>
                            <Input type="text" name="address" id="address" variant="box"
                                value={this.state.form.address.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="city">{this.state.form.city.label}</label>
                            <Input type="text" name="city" id="city" variant="box"
                                value={this.state.form.city.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="state">{this.state.form.state.label}</label>
                            <Input type="text" name="state" id="state" variant="box"
                                value={this.state.form.state.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="country">{this.state.form.country.label}</label>
                            <Input type="text" name="country" id="country" variant="box"
                                value={this.state.form.country.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="zipcode">{this.state.form.zipcode.label}</label>
                            <Input type="text" name="zipcode" id="zipcode" variant="box"
                                value={this.state.form.zipcode.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="telephone">{this.state.form.telephone.label}</label>
                            <Input type="text" name="telephone" id="telephone" variant="box"
                                value={this.state.form.telephone.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="comments">{this.state.form.comments.label}</label>
                            <Input type="text" name="comments" id="comments" variant="box"
                                value={this.state.form.comments.value}
                                onChange={this.handleInputChange}
                                disabled={this.state.submitState == 1}
                                style={inputStyles}
                            />
                        </div>
                    </form>
                    <div className={`message ${this.state.submitState == 2 && "success"} ${this.state.submitState == 3 && "error"}`}>
                        {this.state.submitState == 1 ? "Submitting..." : this.state.message}
                    </div>
                </div>
                <div className="modalContactButtonsContainer">
                    <Button className="button" style={
                        { width: '102px', height: '36px', borderRadius: '2px', marginLeft: '12px' }}
                        type="flat"
                        size="small"
                        title="Cancel"
                        onClick={this.onClose}
                        disabled={this.state.submitState == 1}
                    />
                    <Button className="button" style={
                        { width: '102px', height: '36px', borderRadius: '2px', marginLeft: '12px' }}
                        type="primary"
                        size="small"
                        title="Submit"
                        onClick={this.submitForm}
                        disabled={this.state.submitState == 1}
                    />
                </div>
            </Modal>
        );
    }
}

/* istanbul ignore next */
export default connect(function (store) {
    return {
        activeProject: getActiveProject(store)
    };
}, { hideModalContact })(ModalContact);

